import React from "react";
import { Facebook, Twitter, ShieldCheck, Star } from "lucide-react";

const MAP = {
  facebook: Facebook,
  twitter: Twitter,
  bbb: ShieldCheck,
  angi: Star,
};

export default function SocialIcon({ name, className = "h-4 w-4" }) {
  const Cmp = MAP[name] || Star;
  return <Cmp className={className} strokeWidth={2} />;
}
